import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

import browserReducer from './browser';
import modalsReducer from './modals';
import flowReducer from './flows';
import identityReducer from '../legacy-financial-accounts/reducers';
import requestsReducer from './requests';

export type RootReducer = ReturnType<typeof rootReducer>;

const combinedReducers = combineReducers({
  browser: browserReducer,
  flows: flowReducer,
  identity: identityReducer,
  modals: modalsReducer,
  requests: requestsReducer,
  toastr: toastrReducer,
});

export default function rootReducer(state = {}, action) {
  return combinedReducers(state, action);
}
